import React from 'react';
import styled from "styled-components";

const Vasco = () => {
    return (
        <SectionVasco>
            <p>© Vasco Barreiros 2022</p>
        </SectionVasco>
    );
};

export default Vasco;

const SectionVasco = styled.p`
  position: absolute;
  bottom:0;
  transform: translate(-50%,-50%);
  left:50%;
  
  
  @media (max-width: 768px) {
    display: none;
    visibility: hidden;
  }
    
`